module.exports = __webpack_public_path__ + "fonts/ralewaybolditalic.6b81e0d.woff";